import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { type APIResponse } from "@/lib/types/APIResponse";
import {
  type AvailablePhoneNumber,
  type FirmPhone,
  type SearchAvailablePhoneNumbers,
} from "@/lib/types/Firm";
import { baseFastApiFirmRoute } from "./firm";

export function searchAvailablePhoneNumbersV1({
  areaCode,
  postalCode,
  locality,
  pattern,
  region,
}: SearchAvailablePhoneNumbers) {
  return authenticatedFastApiAxiosInstance
    .post<APIResponse<AvailablePhoneNumber[]>>(
      `${baseFastApiFirmRoute}/phones/search`,
      {
        areaCode,
        postalCode,
        locality,
        pattern,
        region,
      },
    )
    .then((res) => res.data);
}

export function getFirmPhonesV1() {
  return authenticatedFastApiAxiosInstance
    .get<APIResponse<FirmPhone[]>>(`${baseFastApiFirmRoute}/phones`)
    .then((res) => res.data);
}

export function createFirmPhoneV1(data: Pick<FirmPhone, "label" | "number">) {
  return authenticatedFastApiAxiosInstance
    .post<APIResponse<FirmPhone>>(`${baseFastApiFirmRoute}/phones`, data)
    .then((res) => res.data);
}

export function updateFirmPhoneV1(
  data: Pick<FirmPhone, "id" | "dateModified"> & Partial<FirmPhone>,
) {
  return authenticatedFastApiAxiosInstance
    .patch<APIResponse<FirmPhone>>(`${baseFastApiFirmRoute}/phones`, data)
    .then((res) => res.data);
}

export function deleteFirmPhoneV1(data: { id: string }) {
  const { id } = data;
  return authenticatedFastApiAxiosInstance
    .delete<APIResponse<FirmPhone>>(`${baseFastApiFirmRoute}/phones/${id}`)
    .then((res) => res.data);
}
